module.exports = __webpack_public_path__ + "static/media/graph_space.e8862534.png";